import { ModelID, Package, SearchParams } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'package_id' | 'name';
export interface PackageSearchParams extends SearchParams<Filter, Sort>, Partial<Package> {}

export const featurePath = '/v4/location/package';

export const featureKeys = {
  all: [{ scope: 'packages' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: PackageSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
